import { useCallback } from 'react';
import { useToast } from '@/hooks/errors/use-toast';
import { getErrorMessage } from '@/config/error-messages';
import { ToastAction } from '@/components/ui/toast';
import React from 'react';

interface CreditErrorResponse {
  error: string;
  errorType: 'INSUFFICIENT_CREDITS';
  creditCheck: {
    has_sufficient_credits: false;
    available_credits: number;
    required_credits: number;
    user_id: string;
    operation_type: string;
    error_message: string;
  };
}

export const useCreditErrorHandler = () => {
  const { toast } = useToast();

  const handleCreditError = useCallback((errorResponse: CreditErrorResponse) => {
    const errorConfig = getErrorMessage('INSUFFICIENT_CREDITS', errorResponse);
    
    toast({
      variant: 'error',
      title: errorConfig.title,
      description: `${errorConfig.message} Click here to upgrade your plan.`,
      duration: 10000, // Longer duration for important message
      onClick: () => {
        // Open billing page when toast is clicked
        if ('actionUrl' in errorConfig && errorConfig.actionUrl) {
          window.open(errorConfig.actionUrl, '_blank');
        }
      }
    });
  }, [toast]);

  const isInsufficientCreditsError = useCallback((error: any): error is CreditErrorResponse => {
    return error?.errorType === 'INSUFFICIENT_CREDITS' && error?.creditCheck;
  }, []);

  return {
    handleCreditError,
    isInsufficientCreditsError
  };
}; 